import React from 'react'

import {BaseDialog, Role} from 'dialogs/BaseDialog'
import NavigationMenu from './NavigationMenu'
import BasketList from './BasketList'
import ComplaintList from './ComplaintList'
import Header from 'common/Header'
import theme from '../VpqClient.scss'
import conf from 'configuration.json'
import ProgressBar from 'common/ProgressBar'
import PasswordPopup from './PasswordPopup';
import {getMessage as msg} from 'MessageBundle'

export default class VPRekla extends BaseDialog {

    constructor(props) {
        super(props);

        this.state = {
            baskets: [],
            selectedBasket: undefined,
            complaints: [],
            processing: false,
            passwordPopupOpened: false
        };
    }

    getAllowedRoles() {
        return [Role.VPQ_OPERATOR, Role.ADMIN];
    }

    componentDidMount() {
        super.init(() => {
            this.loadBaskets(() => this.setState({initialized: true}));
        });
    };

    loadBaskets = (callback) => {
        this.request('get', conf.rest.basketEndpoint).send((result) => {
            let body = result.body;
            this.setState({
                baskets: body,
            });
            let newSelectedBasket;
            if (this.state.selectedBasket) {
                newSelectedBasket = body.find(b => b.id === this.state.selectedBasket.id);
            } else {
                newSelectedBasket = body[0];
            }
            this.loadComplaints(newSelectedBasket, callback)
        });
    };

    loadComplaints = (basket, callback) => {
        this.request('get', conf.rest.complaintSecureEndpoint + '/' + basket.id).send((result) => {
            const complaints = result.body;
            basket.numberOfIssues = complaints.length;
            this.setState({
                selectedBasket: basket,
                complaints: complaints,
            }, callback);
        });
    };

    handleRefreshClick = () => {
        this.setState({processing: true});
        this.loadBaskets(() => this.setState({processing: false}));
    };

    handleBasketSelect = (basket) => {
        this.setState({processing: true});
        this.loadComplaints(basket, () => this.setState({processing: false}));
    };

    togglePasswordPopup = () => {
        this.setState({
            passwordPopupOpened: !this.state.passwordPopupOpened
        });
    };

    handleSettingClick =() => {
        window.open('/admin', '_blank');
    };

    getDialog() {
        return (
            <div className={theme.client}>
                <Header value={msg('vprekla.header')}>
                    <NavigationMenu logoutTimeout={this.state.logoutTimeout} tvppReturnUrl={this.state.tvppReturnUrl}
                        onSettingsClick={this.state.admin ? this.handleSettingClick : null}
                        tvppLogoutUrl={this.state.tvppLogoutUrl} onRefreshClick={this.handleRefreshClick}
                        onPreferencesClick={this.state.salesManager ? this.togglePasswordPopup : null}
                        ref={(navigationMenu) => this.navigationMenu = navigationMenu}/>
                </Header>
                <section>
                    <BasketList value={this.state.baskets} selectedBasket={this.state.selectedBasket}
                        onSelect={this.handleBasketSelect}/>
                    <ComplaintList value={this.state.complaints} selectedBasket={this.state.selectedBasket} currentUserName={this.state.accountName}
                        isSalesPartnerColumnRendered={this.state.selectedBasket.salesPartnerColumnRendered}/>
                </section>
                <PasswordPopup accountName={this.state.accountName} onClose={this.togglePasswordPopup} visible={this.state.passwordPopupOpened}/>
                <ProgressBar hidden={!this.state.processing} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Start/index.js